import { render } from "./comHomeView.vue?vue&type=template&id=0125e47a"
import script from "./comHomeView.vue?vue&type=script&lang=js"
export * from "./comHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__